// Wire contract — device-targets read filters (DATA-CONTRACTS §device
// targets): equality only, repeated values = IN. Filters SELECT items — an
// item matches when ANY unit in it (root or fronted) matches — and items
// always travel whole; the one exception is `kind`, which additionally
// narrows the service entries themselves (ask for snmp, get snmp — within
// the credential's ceiling). The credential shapes content; filters slice.
import { z } from 'zod';
import { csv } from '../common/query.js';
import { AssetCategorySchema } from '../assets/categories.js';
import { DeviceAccessServiceKindSchema } from '../assets/access.js';
export const DeviceTargetsQuerySchema = z.object({
    site_id: csv(z.string()),
    category: csv(AssetCategorySchema),
    canonical_key: csv(z.string()),
    kind: csv(DeviceAccessServiceKindSchema),
});
